module.exports = __webpack_public_path__ + "img/layers.ffd63d5c.svg";